// SHOW COMPONENTS
export const SHOW_PROFILE_PICTURE = false;
export const SHOW_SETTINGS_ICON = false;
export const SHOW_PROFILE_DESCRIPTION = false;
export const SHOW_CHART_HEADING = true;
export const SHOW_TABLE_HEADING = false;

// APIs
export const SHOW_FAKE_PROFILE_PICTURE = true;
export const GRAPH_API_CONNECTED = false;
export const TABLE_API_CONNECTED = false;

// DUMMY DATA
export const DUMMY_PROFILE_NAME = "Shafeeq Ur Rehman";
export const DUMMY_PROFILE_DESCRIPTION = "This is a description";
export const DUMMY_NEWS_DATA = "News of";

// CONSTANTS
export const HEADER_BUTTON_LABEL = "Logout";
export const CHART_HEADING = "Your Investments";
export const CHART_SUBTITLE = "Chart Subtitle";
export const TABLE_HEADING = "Table Heading";
export const TABLE_SUBTITLE = "Table Subtitle";
export const NEWS_HEADING = "Latest News";

/* ~~~~~~~~~~~~~~~~~~~~~ STYLES ~~~~~~~~~~~~~~~~~~~~~~~~ */
// COLORS
export const SUCCESS = "#0ee000";
export const ERROR = "#ff4f4f";
export const GAP_BETWEEN_SECTIONS = "70px";
export const THEME_COLOR = "#680cfc";
